import cn from 'classnames';
import { Loader } from '../Loader';

export const SectionLoader = ({ className }: { className?: string }) => (
  <div className={cn('w-full h-full min-h-[400px] grid place-items-center', className)}>
    <Loader />
  </div>
);
